import angular from 'angular';
import { sanitize } from '@/shared/utils/htmlHelpers';

angular.module('commonServices').filter('sanitize', [
  function() {
    return function(input) {
      return sanitize(input);
    };
  },
]);
